export default "__VITE_ASSET__9a204a06__"